// extracted by mini-css-extract-plugin
export var numpadContainer = "_mj-1";
export var phoneButton = "_mj-0";